import * as AppConstants from "AppConstants";

export const getUrlForMemberForUser = (userId) => {
    const url = AppConstants.GET_MEMBER_FOR_USER_ENDPOINT
                    .replace(AppConstants.USER_ID_PLACEHOLDER, userId);
    return url;
}

export const getUrlToCreateManager = () => {
    const url = AppConstants.CREATE_MANAGER_ENDPOINT;
    return url;
};

 export const getUrlToUpdateManager = (manager_id) => {
    const url = AppConstants.UPDATE_MANAGER_ENDPOINT
                .replace(AppConstants.MANAGER_ID_PLACEHOLDER, manager_id);
    return url;
};

/**
 * Effort summary URL. clientIds is optional — omitting it keeps the previous behaviour of
 * reporting on every client the caller can see, so an unresolved client list never narrows
 * the scope to nothing.
 * @since NEXT_VERSION
 */
 export const getUrlForLoadEffortSummary = (startDate, endDate, clientIds) => {
    const url = AppConstants.GET_EFFORT_SUMMARY_ENDPOINT
                .replace(AppConstants.FROM_DATE_PLACEHOLDER, startDate)
                .replace(AppConstants.TO_DATE_PLACEHOLDER, endDate);
    const ids = Array.isArray(clientIds) ? clientIds.filter((id) => id != null && id !== "") : [];
    return ids.length > 0 ? `${url}&clientIds=${ids.join(",")}` : url;
};

 export const getUrlToDeleteManager = (manager_id) => {
    const url = AppConstants.DELETE_MANAGER_ENDPOINT
                .replace(AppConstants.MANAGER_ID_PLACEHOLDER, manager_id);
    return url;
};

 export const getUrlToCreateMember = () => {
    const url = AppConstants.CREATE_MEMBER_ENDPOINT;
    return url;
};

 export const getUrlToUpdateMember = (member_id) => {
    const url = AppConstants.UPDATE_MEMBER_ENDPOINT
        .replace(AppConstants.MEMBER_ID_PLACEHOLDER, member_id);
    return url;
};

 export const getUrlToDeleteMember = (member_id) => {
    const url = AppConstants.DELETE_MEMBER_ENDPOINT
        .replace(AppConstants.MEMBER_ID_PLACEHOLDER, member_id);
    return url;
};

export const getUrlForAllMemberReportings = () => {
    const url = AppConstants.GET_MEMBER_REPORTING_ENDPOINT;
    return url;
};

/**
 * Builds the server-paginated members URL with page/sort/search query params.
 * GET /v1/api/members/all/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForMembersPage = ({ page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "name",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${AppConstants.GET_MEMBERS_PAGED_ENDPOINT}?${params.toString()}`;
};

/**
 * Builds the server-paginated member-reporting URL with page/sort/search query params.
 * Member/manager/client fields are enriched after fetch, so the server resolves search by
 * enriching-then-filtering rather than a DB query, but the client contract is the same.
 * GET /v1/api/members/reporting/all/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForMemberReportingsPage = ({ page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "id",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${AppConstants.GET_MEMBER_REPORTING_PAGED_ENDPOINT}?${params.toString()}`;
};

export const getUrlToCreateMemberReporting = () => {
   const url = AppConstants.CREATE_MEMBER_REPORTING_ENDPOINT;
   return url;
};

export const getUrlToUpdateMemberReporting = (member_id) => {
   const url = AppConstants.UPDATE_MEMBER_REPORTING_ENDPOINT
       .replace(AppConstants.MEMBER_ID_PLACEHOLDER, member_id);
   return url;
};

export const getUrlToDeleteMemberReporting = (member_id) => {
   const url = AppConstants.DELETE_MEMBER_REPORTING_ENDPOINT
       .replace(AppConstants.MEMBER_ID_PLACEHOLDER, member_id);
   return url;
};